export const downloadUrlFor = (url, product_ids) => {
  if (product_ids.length == 0) {
    return "#";
  }

  url += "?";

  product_ids.forEach(product_id => {
    url += "product_ids[]=" + product_id + "&";
  });

  url = url.slice(0, -1);

  return encodeURI(url);
};
